export const field = 'w-full rounded-button border border-hairline bg-surface p-2.5 text-body-sm text-ink focus:outline-none focus:ring-2 focus:ring-accent'
export const labelCls = 'block text-caption text-ink-muted mb-1'

type BadgeVariant = 'neutral' | 'success' | 'teal' | 'warning' | 'info'
export const EDITION_STATUS: Record<string, { label: string; variant: BadgeVariant }> = {
  draft: { label: 'Draft', variant: 'warning' },
  active: { label: 'Live', variant: 'success' },
  superseded: { label: 'Retired', variant: 'neutral' },
}
export const DOCUMENT_STATUS: Record<string, { label: string; variant: BadgeVariant }> = {
  uploaded: { label: 'Ready to extract', variant: 'info' },
  extracted: { label: 'Extracted', variant: 'teal' },
  in_review: { label: 'Being checked', variant: 'warning' },
  approved: { label: 'Approved', variant: 'success' },
  rejected: { label: 'Removed', variant: 'neutral' },
}

